// STR field names are defined next to the fields (pages/.../options.jsx).
import { STR_UPLOAD_ARRAY_PATH } from '../pages/supportingEvidence/serviceTreatmentRecords/options';

export const SHA_UPLOADS_KEY = 'separationHealthAssessmentUploads';

export const VALID_ADDRESS_KEYS = [
  'country',
  'addressLine1',
  'addressLine2',
  'addressLine3',
  'city',
  'state',
  'zipCode',
];

export const ADDRESS_FIELDS_TO_NORMALIZE = [
  'addressLine1',
  'addressLine2',
  'addressLine3',
  'city',
];

// Top-level keys accepted by the `21-526EZ-ALLCLAIMS-V2` schema (which sets
// additionalProperties: false) plus `attachments`, which the vets-api
// controller reads but the published schema does not yet describe.
export const WIRE_TOP_LEVEL_KEYS = [
  'veteranIdentification',
  'isCurrentlyHomelessOrIsAtRiskOfBecomingHomeless',
  'isTerminallyIll',
  'serviceInformation',
  'powStatus',
  'powEraCampaign',
  'powConfinement',
  'ratedDisabilities',
  'newDisabilities',
  'statementOfTruthCertified',
  'evidence',
  'vaTreatmentFacilities',
  'directDeposit',
  'servicePay',
  'form0781',
  'form4142',
  'attachments',
  'hasUserUploadedSha',
];

// Checkbox key (see SERVICE_*_LABELS) -> value in the schema's serviceBranch /
// component enums.
export const SERVICE_BRANCH_ENUM_BY_KEY = {
  army: 'ARMY',
  airForce: 'AIR_FORCE',
  navy: 'NAVY',
  marineCorps: 'MARINE_CORPS',
  coastGuard: 'COAST_GUARD',
  spaceForce: 'SPACE_FORCE',
  noaa: 'NOAA',
  usphs: 'USPHS',
};

// bankAccountUI accountType key -> value in the schema's directDeposit
// accountType enum.
export const ACCOUNT_TYPE_ENUM_BY_KEY = {
  checking: 'CHECKING',
  savings: 'SAVINGS',
};

export const SERVICE_COMPONENT_ENUM_BY_KEY = {
  active: 'ACTIVE',
  reserves: 'RESERVES',
  nationalGuard: 'NATIONAL_GUARD',
};

// Form facility type -> `evidence.facilityType`. `NOT_SURE` is not a Lighthouse
// value; vets-api removes it before building the Lighthouse request.
export const EVIDENCE_FACILITY_TYPES = {
  vaMedicalCenter: 'VAMC_AND_CBOC',
  cboc: 'VAMC_AND_CBOC',
  dodMtf: 'DEPARTMENT_OF_DEFENSE_(DOD)_MTF',
  privateProvider: 'PRIVATE_HEALTHCARE_PROVIDER',
  vetCenter: 'VET_CENTER(S)',
  communityCare: 'COMMUNITY_CARE',
  other: 'OTHER',
  notSure: 'NOT_SURE',
};

export const FORM_0781_KEYS = [
  'eventTypes',
  'events',
  'workBehaviors',
  'healthBehaviors',
  'otherBehaviors',
  'behaviorsDetails',
  'supportingEvidenceReports',
  'supportingEvidenceRecords',
  'supportingEvidenceWitness',
  'supportingEvidenceOther',
  'supportingEvidenceUnlisted',
  'supportingEvidenceNoneCheckbox',
  'treatmentReceivedVaProvider',
  'treatmentReceivedNonVaProvider',
  'treatmentNoneCheckbox',
  'optionIndicator',
  'additionalInformation',
];

export const BEHAVIOR_KEYS = [
  'workBehaviors',
  'healthBehaviors',
  'otherBehaviors',
  'behaviorsDetails',
];

// Loops built with the array builder; each item is `{ uploadedDocument, attachmentId }`.
export const UPLOAD_LOOP_KEYS = [
  'additionalDocumentsLoop',
  'privateMedicalRecordsUploads',
  STR_UPLOAD_ARRAY_PATH,
];
